import { FindingsLabel } from '@app/icare/components/findings'
import { selectByFindingId } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { AddButton } from '@pkg/ui/button'
import { useRouterTabs } from '@pkg/ui/hooks/useRouterTabs'
import { useExtra, useTabs } from '@pkg/ui/layout/PageContainer'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { Dropdown } from 'antd'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/unterschriftsdokumente')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const tabs = useRouterTabs({ basePath: `/patienten/${id}/unterschriftsdokumente` })

  useTabs(
    {
      ...tabs,
      items: [
        {
          key: '/',
          label: <Trans>Übersicht</Trans>,
        },
        {
          key: '/patienteninformationen',
          label: (
            <FindingsLabel
              label={t`Patienteninformationen`}
              selector={selectByFindingId('FormsPatientInformationRequired')}
            />
          ),
        },
        {
          key: '/einwilligung-schweigepflicht',
          label: (
            <FindingsLabel
              label={t`Einwilligung & Schweigepflicht`}
              selector={selectByFindingId('FormsPatientConsentAndConfidentialityRequired')}
            />
          ),
        },
        {
          key: '/versorgungsauftrag',
          label: (
            <FindingsLabel label={t`Versorgungsauftrag`} selector={selectByFindingId('FormsPatientSupplyRequired')} />
          ),
        },
      ],
    },
    [tabs.activeKey],
  )

  useExtra(
    <Dropdown
      menu={{
        items: [
          {
            key: 'patienteninformationen',
            label: (
              <Link to={'/patienten/$id/patienten-information/$form'} params={{ id, form: 'new' }}>
                <Trans>Patienteninformation</Trans>
              </Link>
            ),
          },
          {
            key: 'einwilligung-schweigepflicht',
            label: (
              <Link to={'/patienten/$id/einwilligung-schweigepflicht/$form'} params={{ id, form: 'new' }}>
                <Trans>Einwilligung & Schweigepflicht</Trans>
              </Link>
            ),
          },
          {
            key: 'versorgungsauftrag',
            label: (
              <Link to={'/patienten/$id/versorgungsauftrag/$form'} params={{ id, form: 'new' }}>
                <Trans>Versorgungsauftrag</Trans>
              </Link>
            ),
          },
        ],
      }}
    >
      <AddButton size="small">
        <Trans>Unterschriftdokument erstellen</Trans>
      </AddButton>
    </Dropdown>,
    [],
  )

  return <Outlet />
}
